SupportAPIHelper = require('../helpers/API')
async = require('../../../../core/frontend/vendor_modules/async')
SupportUtilsHelper = require('../helpers/utils')
Backbone = require 'backbone'

class SupportOrderModel extends Backbone.Model

  constructor: () ->
    @orderDetailMap = {}
    @orderMetadataMap = {}

  findOrderDetailsByOrderId: (orderId) ->
    if orderId
      orderId = orderId.toString()
      @orderDetailMap[orderId]
    else
      null

  setOrderDetails: (order) ->
    if order?.id
      orderId = order.id.toString()
      @orderDetailMap[orderId] = order

  findOrderMetaDataByOrderId: (orderId) ->
    if orderId
      orderId = orderId.toString()
      @orderMetadataMap[orderId]
    else
      null

  setOrderMetaData: (orderId, metadata) ->
    if orderId && metadata
      orderId = orderId.toString()
      @orderMetadataMap[orderId] = metadata

  getOrderDetailsForMygrouponsOrderId: (successCallback, errorCallback) ->
    unless window.orderIdFromMyGroupons
      return errorCallback()
    orderIdFromMyGroupons = window.orderIdFromMyGroupons

    requests =
      orderDetailsMyGrouponOrder: (cb) =>
        params =
          order: {
            id: orderIdFromMyGroupons
          }
          forceFetchOrderDetails: true

        if orderIdFromMyGroupons?
          order = Groupon.Support.OrdersCollection.findOrderById(orderIdFromMyGroupons)
          if order
            params.order = order
            params.forceFetchOrderDetails = false

        _successCb = (response) ->
          cb(null, response)

        _errorCb = () ->
          cb(null, null)

        @getOrderDetails params, _successCb, _errorCb

      orderDetailsFirstOrder: (cb) =>
        paramOrder = Groupon.Support.currentOrdersFilter.getFirstOrder()
        if paramOrder?.id && orderIdFromMyGroupons && paramOrder?.id.toString() is orderIdFromMyGroupons.toString()
          return cb(null, null)
        params =
          order: paramOrder
          forceFetchOrderDetails: false
        _successCb = (response) ->
          cb(null, response)

        _errorCb = () ->
          cb(null, null)
        @getOrderDetails params, _successCb, _errorCb

    async.parallel requests, (err, results) =>
      if err
        errorCallback()
      else
        if results.orderDetailsMyGrouponOrder?
          window.selectOrderFromMygroupons = true
          successCallback(results.orderDetailsMyGrouponOrder)
        else if results.orderDetailsFirstOrder
          window.selectOrderFromMygroupons = false
          successCallback(results.orderDetailsFirstOrder)
        else
          errorCallback()

  getOrderDetails: (params, successCallback, errorCallback) ->
    orderSummary = params.order

    orderDetails = @findOrderDetailsByOrderId(orderSummary?.id)
    if orderDetails && (not params.forceFetchOrderDetails)
      return successCallback(orderDetails)

    _orderDetailSuccessCallback = (orderDetails) =>
      orderDetails.isOrderDetailsFetched = true
      @setOrderDetails(orderDetails)
      @associateHotelImages(orderDetails)
      successCallback(orderDetails)

    _orderDetailsErrorCallback = () ->
      errorCallback(orderSummary)

    if checkIfIsUSByCountry(window.country.name)
      url = switch orderSummary.DEAL_TYPE
        when 'GETAWAYS_MARKET_RATE' then @getawaysHotelReservationDetailsPath orderSummary.id
        when 'GETAWAYS_TONIGHT' then @getawaysHotelReservationDetailsPath orderSummary.id
        else @orderDetailsPath orderSummary, params
      SupportAPIHelper.get url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false
    else if window.isNeedish()
      params.forceFetchOrderDetails =  true
      url = @orderDetailsPath orderSummary, params
      SupportAPIHelper.get url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false
    else
      if orderSummary.deal?.isTravelBookableDeal || orderSummary.deal?.isBookableTravelDeal
         return _orderDetailSuccessCallback(orderSummary)
      if orderSummary.DEAL_TYPE is 'GETAWAYS_MARKET_RATE'
        url = @getawaysHotelReservationDetailsPath orderSummary.id
        SupportAPIHelper.get url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false
      else if params.forceFetchOrderDetails
        url = @orderDetailsPath orderSummary, params
        SupportAPIHelper.get url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false
      else
        @getDealInfo params, successCallback, errorCallback

  getDealInfo: (params, successCallback, errorCallback) ->
    orderDetails = params.order

    if orderDetails.isDealDataFetched
      return successCallback(orderDetails)

    _dealInfoSuccessCallback = (deal) =>
      _.extend orderDetails.deal, deal
      if deal.DEAL_TYPE? then orderDetails.DEAL_TYPE = deal.DEAL_TYPE
      orderDetails.finePrintText = deal.finePrintText
      orderDetails.isDealDataFetched = true
      successCallback(orderDetails)

    _dealInfoErrorCallback = () ->
      errorCallback(orderDetails)

    url = @dealDetailsPath orderDetails.deal.id
    SupportAPIHelper.get url, {purchasedAt: orderDetails.purchasedAt}, _dealInfoSuccessCallback, _dealInfoErrorCallback, false

  getMetadata: (params, successCallback, errorCallback) ->
    orderDetails = params.order
    _metadataSuccessCallback = (response) =>
      orderDetails.isMetaDataFetched = true
      @setOrderMetaData(orderDetails?.id, response)
      @setCurrentOrderAttributes {orderDetails, orderMetadata: response}, successCallback

    metadataResponse = @findOrderMetaDataByOrderId(orderDetails?.id)
    if metadataResponse?
      return _metadataSuccessCallback(metadataResponse)

    metadataUrl = "#{window.SUPPORTBASEURL}/metadata?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"
    orderData =
      groupon : orderDetails
      channel : orderDetails.DEAL_TYPE
    orderDetails.user = currentUser
    SupportAPIHelper.call metadataUrl, 'POST', orderData, _metadataSuccessCallback, errorCallback, false

  setCurrentOrderAttributes: ({orderMetadata, orderDetails}, callback) ->
    orderDetails.serviceActions = orderMetadata.serviceActions
    orderDetails.tagLine = orderMetadata.tagLine
    if orderMetadata.priorityTaglines? then orderDetails.priorityTaglines = orderMetadata.priorityTaglines
    if orderMetadata.finePrintText? then orderDetails.finePrintText = orderMetadata.finePrintText
    if orderMetadata.status? then Groupon.Support.ContentModel.displayStatus = orderMetadata.status
    if orderMetadata.notes? then Groupon.Support.ContentModel.displayNotes  = orderMetadata.notes
    if orderMetadata.external_notes? then Groupon.Support.ContentModel.externalDealNotes = orderMetadata.external_notes
    if orderMetadata.shouldShowDeliveryMsg? then orderDetails.shouldShowDeliveryMsg = orderMetadata.shouldShowDeliveryMsg else orderDetails.shouldShowDeliveryMsg = false
    if orderMetadata.goodsDealFulfillmentTag? then orderDetails.goodsDealFulfillmentTag = orderMetadata.goodsDealFulfillmentTag
    if orderMetadata.isRefundEligible? then orderDetails.isRefundEligible = orderMetadata.isRefundEligible
    if orderMetadata.escalateToMerchant? then orderDetails.escalateToMerchant = orderMetadata.escalateToMerchant

    if $.inArray('edit_order', orderDetails.serviceActions) > -1 ||
    $.inArray('cancel_order', orderDetails.serviceActions) > -1 ||
    $.inArray('cancel_reservations', orderDetails.serviceActions) > -1
      orderDetails.isEditable = true
      orderDetails.isEditableUntil = orderMetadata.editableUntillongDateTimeStr
      orderDetails.editableUntilshortDateTimeStr = orderMetadata.editableUntilshortDateTimeStr
      orderDetails.editableUntillongDateTimeStr = orderMetadata.editableUntillongDateTimeStr
    else
      orderDetails.isEditable = false

    if orderMetadata?.inbentaParams?
      Groupon.Support.ContentModel.extendParams(orderMetadata.inbentaParams)
    callback(orderDetails)

  associateHotelImages: (order) ->
    if order.DEAL_TYPE is 'GETAWAYS_MARKET_RATE'
      savedData = Groupon.Support.OrdersCollection.getHotelImageByOrderId(order.id)
      reservationSource = SupportUtilsHelper.getReservationSource(order)
      if reservationSource? && savedData
        reservationSource.images = savedData.images
    order

  dealDetailsPath: (dealId) ->
    "#{window.SUPPORTBASEURL}/deal/#{dealId}"

  orderDetailsPath: (order, params) ->
    query = ""
    if order?
      if order.groupons?.length > 0
        groupon = _.first order.groupons
        if groupon.id
          query = "#{query}groupon_id=#{groupon.id}&"
    if params
      if params.isRefundEligible
        query = "#{query}is_refund_eligible=true&"
      if params.forceFetchOrderDetails
        query = "#{query}mygroupon_show=true&"

    "#{window.SUPPORTBASEURL}/user/#{currentUser.id}/order/#{order.id}?#{query}"

  getawaysHotelReservationDetailsPath: (reservationId) ->
    if checkIfIsUSByCountryCluster(window.country.cluster)
      parts = currentUser.consumerId?.split("-")
      consumerId = _.reduce parts, (memo, part) -> "#{memo}#{part}"
      return "#{window.SUPPORTBASEURL}/user/#{consumerId}/getaways_hotel_reservation/#{reservationId}"
    else
      user_id = currentUser.id
      return "#{window.SUPPORTBASEURL}/user/#{user_id}/getaways_hotel_reservation/#{reservationId}"

module.exports = SupportOrderModel
